import React from "react";

// Helper function to render table cells
const renderCell = (value) => value ?? "-";

const MtfPosReportTable = (props) => {
  const { data } = props;

  const headers = 
     ["Process Date","Client Name", "Scrip Name","Scrip Code","Series","BSE CODE", 
        "ISIN","Avg. Price","Quantity","Funded Value" ]
   

  const renderHeaders = headers.map((header, index) => (
    <th key={index} scope="col" className="text-center">
      {header}
    </th>
  ));

  const renderRows = (item) => {
 
      return (
        <>
          <td>{renderCell(item.date) || "-"}</td>
          <td>{renderCell(item.clientName)}</td>
          <td>{renderCell(item.scripName)}</td>
          <td>{renderCell(item.scripCode)}</td>
          <td>{renderCell(item.series)}</td>
          <td>{renderCell(item.bseCode)}</td>
          <td>{renderCell(item.isin)}</td>
          <td>{renderCell(item.avgPrice)}</td>
          <td>{renderCell(item.quantity)}</td>
          <td>{renderCell(item.fundedValue)}</td>
        </>
      );
    

  };

  return (
    <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table last-column mtf-pos-table">
        <thead>
          <tr>{renderHeaders}</tr>
        </thead>
        <tbody>
          {data && data.map((item, key) => (
            <tr key={key}>
              {renderRows(item)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MtfPosReportTable;
